import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { GET_PROJECT_APPLICATION } from 'gql/projectApplications';
import ApplicationDetail from './ApplicationDetail';
import EndorsementSection from './EndorsementSection';
import CancelProjectApplication from './CancelProjectApplication';
import EndorsementHistory from './EndorsementHistory';
import { GET_ME } from 'gql/auth';
import { getMax } from 'utils';

const maxEndorsementSequence = getMax('endorsementSequence');

const PendingProjectApplication = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION, {
    variables: { id: id },
  });
  const { data: meData, loading: meLoading } = useQuery(GET_ME);
  const initTab = maxEndorsementSequence(
    data?.projectApplication?.applicationEndorsements?.endorsements
  );

  return (
    <>
      {data?.projectApplication?.user?.id === meData?.me?.id && (
        <CancelProjectApplication />
      )}
      <EndorsementHistory
        data={data?.projectApplication?.applicationEndorsements}
        initTab={initTab}
        defaultCollapsed
      />
      <ApplicationDetail
        data={data?.projectApplication}
        loading={loading || meLoading}
      />
      <EndorsementSection
        data={data?.projectApplication?.currentEndorsement}
        loading={loading || meLoading}
      />
    </>
  );
};

export default PendingProjectApplication;
